module.exports = __webpack_public_path__ + "img/silver2.b9b198a8.png";